// Dummy/sample list for initial implementation - NOT a complete clinical reference.
// TODO: replace with a generated list sourced from a government/TGA weight-based dosing register,
// following the same "generate a list, name-check against it" approach as TallmanLettering.js.
const weightDependentDrugs = [
    "warfarin",
    "gentamicin",
    "vancomycin",
    "digoxin",
    "heparin",
    "enoxaparin",
    "amikacin",
    "tobramycin",
    "carboplatin",
    "methotrexate",
    "amphotericin",
    "colistin",
    "teicoplanin",
    "daptomycin",
];

export function isWeightDependentDrug(name) {
    if (!name) return false;

    const lowerName = String(name).toLowerCase();
    const words = lowerName.split(/(\s+|\+|-|\/|\(|\)|,)/);

    return words.some(word => weightDependentDrugs.includes(word));
}

export function getWeightDependentDrugList() {
    return [...weightDependentDrugs];
}
